import {Component} from '@angular/core';
import {constants} from "../../constants";

declare var window: any;

@Component({
  selector: 'app-mobile-apps-page',
  templateUrl: './mobile-apps-page.component.html',
  styleUrls: ['./mobile-apps-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class MobileAppsPageComponent {

  constructor() {
    let storeUrl = this.getAppStoreUrl();

    if (storeUrl) {
      window.location.href = storeUrl;
    }
  }

  getAppStoreUrl() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/huawei/i.test(userAgent)) {
      return constants.appGalleryLink;
    }
    if (/android/i.test(userAgent)) {
      return constants.googlePlayLink;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return constants.appStoreLink;
    }
    return null;
  }
}
